import type { OptionType } from '@atlassian/jira-portfolio-3-common/src/select/types';
import {
	getDerivedRollupBy,
	getDerivedRollupHierarchyLevel,
	getGroupBy,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/dependencies';
import { getHierarchyLevels } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/hierarchy';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import {
	createSelector,
	createStructuredSelector,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { OwnProps, StateProps } from './types';

const getHierarchyItems = createSelector([getHierarchyLevels], (hierarchy): OptionType[] =>
	hierarchy.map(({ title, level }) => ({
		label: title,
		value: level,
	})),
);

export default createStructuredSelector<State, OwnProps, StateProps>({
	groupBy: getGroupBy,
	hierarchy: getHierarchyItems,
	rolledUpHierarchyLevel: getDerivedRollupHierarchyLevel,
	rollupBy: getDerivedRollupBy,
});
